import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteStudentScholarshipOperation = async (
  userId: number,
  scholarshipId: number,
) => {
  try {
    const response = await appApi.deleteStudentScholarship(
      userId,
      scholarshipId,
    );

    if (response.data.errCode) {
      toast.warn(displayErrorText(response.data.errCode));
      return;
    }

    if (!response.data.ok) {
      toast.error('מחיקת המלגה נכשלה');
      return;
    }

    toast.success('המלגה נמחקה בהצלחה');

    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;
  } catch (error) {
    console.error(
      `deleteStudentScholarshipOperation failed with error: ${error}`,
    );
    toast.error('אירעה שגיאה בעת מחיקת המלגה');
  }
};
